// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dda4d738","952":"e8fbe290"}[chunkId] + ".chunk.js";
};